import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestSettings = {
    path: "/settings",
    method: RouteHttpVerb.GET
};
